export default "__VITE_ASSET__57eac3e9__"